// Importing React classes and functions from node modules
import React, { useState, useEffect } from "react";
import { createAnnouncements, getAnnouncements, deleteAnnouncements, sendAnnouncementEmail, fetchCSRF } from "../data/repository";
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import parse from 'html-react-parser';
import ReactSwitch from 'react-switch';

function Announcements(props) {

    const [errorMessage, setErrorMessage] = useState(null);
    const [announcement, setAnnouncement] = useState("");
    const [announcements, setAnnouncements] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [checked, setChecked] = useState(true);
    const [csrfToken, setCsrfToken] = useState(null);

    var IFRAME_SRC = '//cdn.iframe.ly/api/iframe';
    var API_KEY = 'ec1627000e306b7c55174b';
    // var API_HOST = 'http://localhost:4000';
    var API_HOST = 'https://masrooracademyvic.com.au';


    useEffect(() => {

        // Loads Announcements from DB
        async function loadAnnouncements() {
            const currentAnnouncements = await getAnnouncements();

            setAnnouncements(currentAnnouncements);
            setIsLoading(false);
        }

        // Calls the functions above
        loadAnnouncements();
    }, []);


    // Call fetchCSRF and set token once
    if (!csrfToken) {
        fetchCSRF().then(setCsrfToken); // no useEffect
    }

    if (!csrfToken) {
        return <p className="text-center">Loading announcements editor...</p>; // wait for token
    }

    const editorConfig = {
        simpleUpload: {
            uploadUrl: `${API_HOST}/MAApi/image/upload`,
            withCredentials: true,
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        },
        mediaEmbed: {
            previewsInData: true,
            providers: [
                {
                    // hint: this is just for previews. Get actual HTML codes by making API calls from your CMS
                    name: 'iframely previews',

                    // Match all URLs or just the ones you need:
                    // url: /.+/,
                    url: /^https?:\/\/(www\.)?(youtube\.com|twitter\.com|vimeo\.com|soundcloud\.com)\//,


                    html: match => {
                        const url = match[0];

                        var iframeUrl = IFRAME_SRC + '?app=1&api_key=' + API_KEY + '&url=' + encodeURIComponent(url);
                        // alternatively, use &key= instead of &api_key with the MD5 hash of your api_key
                        // more about it: https://iframely.com/docs/allow-origins

                        return (
                            // If you need, set maxwidth and other styles for 'iframely-embed' class - it's yours to customize
                            '<div class="iframely-embed" style="width: 100%">' +
                            '<div class="iframely-responsive">' +
                            `<iframe src="${iframeUrl}" ` +
                            'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
                            '</iframe>' +
                            '</div>' +
                            '</div>'
                        );
                    }
                }
            ]
        }
    }

    // Handler for when textbox value changes
    const handleInputChange = (event, editor) => {
        const data = editor.getData();
        setAnnouncement(data);
        setErrorMessage("");
    };

    // Handler for Switch
    const handleToggleChange = async (event) => {
        setChecked(event);
    }

    // Generic Form Submission Handler
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Trim the Announcement text.
        const trimmedAnnouncement = announcement.trim();

        // Validation Code
        if (trimmedAnnouncement === "") {
            setErrorMessage("Annoucement is Empty!");
            return;
        }

        // Create an Announcement.
        const newAnnoucement = { announcementText: trimmedAnnouncement, announcementDate: new Date().toLocaleString(), id: props.user.id, sendToAll: checked, gender: props.user.gender, group: props.user.group };
        await createAnnouncements(newAnnoucement);

        // Update Page/Refresh the Data
        const currentAnnouncements = await getAnnouncements();
        setAnnouncements(currentAnnouncements);

        // Reset Announcement content.
        setAnnouncement("");
        setErrorMessage("");

        // Send Announcement Email
        await sendAnnouncementEmail(newAnnoucement);
    };

    const canDeleteAnnouncement = (user, post) => {
        const isAdmin = user.group === "Admin";
        const isPostOwner = user.id === post.user.id;
        const isMalePrincipal = user.group === "Principal" && user.gender === "Male";
        const isMaleVicePrincipal = user.group === "Vice Principal" && user.gender === "Male";
        const isFemaleVicePrincipal = user.group === "Vice Principal" && user.gender === "Female";
        const isFemalePrincipal = user.group === "Principal" && user.gender === "Female";
        const isMaleAdminStaff = user.group === "Admin Staff" && user.gender === "Male";
        const isFemaleAdminStaff = user.group === "Admin Staff" && user.gender === "Female";

        const postIsByMaleTeacher = post.user.group === "Male Teacher";
        const postIsByFemaleTeacher = post.user.group === "Female Teacher";
        const postIsByAdminStaff = post.user.group === "Admin Staff";
        const postIsByPrincipal = post.user.group === "Principal";
        const postIsByFemale = post.user.gender === "Female";
        const postIsByMale = post.user.gender === "Male";

        // Admin can delete any post
        if (isAdmin) return true;

        // Users can delete their own posts
        if (isPostOwner) return true;

        // Male Principal can delete all posts except Admin's
        if (isMalePrincipal) {
            return post.user.group !== "Admin";
        }

        // Male Vice Principal can delete all posts except Male Principal's and Admin's
        if (isMaleVicePrincipal) {
            return !(post.user.group === "Principal" && postIsByMale) && post.user.group !== "Admin";
        }

        // Female Vice Principal can delete posts by all female users except Female Principal
        if (isFemaleVicePrincipal) {
            return postIsByFemale && !(postIsByPrincipal && postIsByFemale);
        }

        // Female Principal can delete posts by all female users
        if (isFemalePrincipal) {
            return postIsByFemale;
        }

        // Male Admin Staff can delete posts by Male Teachers and Male Admin Staff
        if (isMaleAdminStaff) {
            return postIsByMaleTeacher || (postIsByAdminStaff && postIsByMale);
        }

        // Female Admin Staff can delete posts by Female Teachers and Female Admin Staff
        if (isFemaleAdminStaff) {
            return postIsByFemaleTeacher || (postIsByAdminStaff && postIsByFemale);
        }

        // Male and Female Teachers can only delete their own posts (already covered by isPostOwner)

        return false;
    };

    const canViewAnnouncement = (user, announcement) => {
        // Helper variables to check user group and gender
        const isAdmin = user.group === "Admin";
        const isAnnouncementOwner = user.id === announcement.user.id;
        const isMalePrincipal = user.group === "Principal" && user.gender === "Male";
        const isMaleVicePrincipal = user.group === "Vice Principal" && user.gender === "Male";
        const isFemalePrincipal = user.group === "Principal" && user.gender === "Female";
        const isFemaleVicePrincipal = user.group === "Vice Principal" && user.gender === "Female";
        const isMaleAdminStaff = user.group === "Admin Staff" && user.gender === "Male";
        const isFemaleAdminStaff = user.group === "Admin Staff" && user.gender === "Female";
        const isMaleTeacher = user.group === "Male Teacher";
        const isFemaleTeacher = user.group === "Female Teacher";

        // Helper variables to check the group and gender of the announcement poster
        const announcementIsByMaleTeacher = announcement.user.group === "Male Teacher";
        const announcementIsByFemaleTeacher = announcement.user.group === "Female Teacher";
        const announcementIsByAdminStaff = announcement.user.group === "Admin Staff";
        const announcementIsByPrincipal = announcement.user.group === "Principal";
        const announcementIsByVicePrincipal = announcement.user.group === "Vice Principal";
        const announcementIsByFemale = announcement.user.gender === "Female";
        const announcementIsByMale = announcement.user.gender === "Male";
        const announcementIsByMalePrincipal = announcement.user.group === "Principal" && announcement.user.gender === "Male";
        const announcementIsByMaleVicePrincipal = announcement.user.group === "Vice Principal" && announcement.user.gender === "Male";
        const announcementIsByAdmin = announcement.user.group === "Admin";

        // Admin can view any announcement
        if (isAdmin) return true;

        // Users can view their own announcements
        if (isAnnouncementOwner) return true;

        // Male Principal can view all announcements
        if (isMalePrincipal) return true;

        // Male Vice Principal can view all announcements
        if (isMaleVicePrincipal) return true;

        // Female Principal and Female Vice Principal can view all announcements from female users,
        // and announcements from Male Principal, Admin, and Male Vice Principals if sendToAll is true
        if (isFemalePrincipal || isFemaleVicePrincipal) {
            if (announcementIsByFemale) {
                return true;
            }
            if ((announcementIsByMalePrincipal || announcementIsByAdmin || announcementIsByMaleVicePrincipal) && announcement.sendToAll) {
                return true;
            }
            return false;
        }

        // Male Admin Staff can only view announcements by Male Principal, Admin, Male Admin Staff, and Male Teachers
        if (isMaleAdminStaff) {
            return announcementIsByMalePrincipal || announcementIsByAdmin ||
                (announcementIsByAdminStaff && announcementIsByMale) ||
                announcementIsByMaleTeacher ||
                announcementIsByMaleVicePrincipal;
        }

        // Female Admin Staff can view announcements by Male Principal (only if sendToAll=true), Admin (only if sendToAll=true), Female Admin Staff, Female Teachers, Female Principals, and Female Vice Principals
        if (isFemaleAdminStaff) {
            if ((announcementIsByMalePrincipal || announcementIsByAdmin || announcementIsByMaleVicePrincipal) && announcement.sendToAll) {
                return true;
            }
            return (announcementIsByAdminStaff && announcementIsByFemale) ||
                announcementIsByFemaleTeacher ||
                (announcementIsByPrincipal && announcementIsByFemale) ||
                (announcementIsByVicePrincipal && announcementIsByFemale);
        }

        // Female Teachers can view announcements by Male Principal (only if sendToAll=true), Admin (only if sendToAll=true), Female Vice Principal, Female Principal, Female Admin Staff announcements, and other Female Teachers
        if (isFemaleTeacher) {
            if ((announcementIsByMalePrincipal || announcementIsByAdmin || announcementIsByMaleVicePrincipal) && announcement.sendToAll) {
                return true;
            }
            return (announcementIsByVicePrincipal && announcementIsByFemale) ||
                (announcementIsByPrincipal && announcementIsByFemale) ||
                (announcementIsByAdminStaff && announcementIsByFemale) ||
                announcementIsByFemaleTeacher;
        }

        // Male Teachers can view announcements by Male Principal, Admin, Male Admin Staff, Male Teachers, and Male Vice Principals
        if (isMaleTeacher) {
            return announcementIsByMalePrincipal || announcementIsByAdmin ||
                (announcementIsByAdminStaff && announcementIsByMale) ||
                announcementIsByMaleTeacher ||
                announcementIsByMaleVicePrincipal;
        }

        // If none of the above conditions are met, the user cannot view the announcement
        return false;
    };


    return (
        <div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit} >
                <div className="form-group">
                    <h3 className="text-center">Add Announcements:</h3>
                    <h5 className="text-center"> Please Delete Announcements that are no longer valid!</h5>
                    <div className="richTextEditor">
                        <CKEditor editor={Editor} data={announcement} onChange={handleInputChange} config={editorConfig} />
                    </div>
                </div>
                {errorMessage && (
                    <p style={{ color: "red", textAlign: "center", fontSize: "18px", margin: "10px 10px 10px 10px" }}>{errorMessage}</p>
                )}
                {(props.user.group === "Admin" || (props.user.group === "Principal" && props.user.gender === "Male") || (props.user.group === "Vice Principal" && props.user.gender === "Male")) &&
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <span style={{ marginRight: "5px" }}>Send to All Boys and Girls, Turn off if only to Boys </span><ReactSwitch checked={checked} onChange={handleToggleChange} />
                    </div>
                }
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" style={{ margin: "5px", padding: "5px 25px 5px 25px" }} className="text-center btn btn-outline-primary2" >Add</button>
                    <button type="button" style={{ margin: "5px" }} className="text-center btn btn-outline-danger" onClick={() => { setAnnouncement(""); setErrorMessage(null); }} >Clear</button>
                </div>
            </form>
            <p>&nbsp;</p>

            {isLoading ?
                <div className="card-body text-center">
                    <span className="text-muted">Loading Annoucements...</span>
                </div>
                :
                <>
                    {announcements.length === 0 ?
                        <div className="text-center">
                            <span className="text-muted">No Annoucements have been Posted!</span>
                            <p>&nbsp;</p>
                        </div>
                        :
                        <>
                            {announcements.filter(announcement => canViewAnnouncement(props.user, announcement)).map((announcement) =>
                                <div key={announcement.announcement_id}>


                                    <div className="postedContent card" style={{ minWidth: "50%", overflowX: "auto" }} >
                                        <div className="card-body">
                                            <h5 style={{ float: "left", textAlign: "center" }} className="card-title">
                                                {announcement.user.gender === "Female" && announcement.user.group === "Principal" ?
                                                    `${announcement.user.name} - In Charge Girls Section` // If the announcement is made by a female Principal, display "In Charge Girls Section"
                                                    : announcement.user.gender === "Female" && announcement.user.group === "Vice Principal" ?
                                                        `${announcement.user.name} - Vice In Charge Girls Section`
                                                        : `${announcement.user.name} - ${announcement.user.group}`}
                                            </h5>
                                            <span style={{ float: "right", textAlign: "center", color: "#212121" }}>{new Date(announcement.announcementDate).toLocaleString("en-AU", { hour12: true, hour: 'numeric', minute: 'numeric', day: "numeric", month: "short", year: "numeric" })}</span>
                                            <div className="post-body">
                                                <pre className="postStyle card-text imgAnnouncementHomework" style={{ whiteSpace: 'pre-wrap' }}>{parse(announcement.announcementText)}</pre>

                                                {canDeleteAnnouncement(props.user, announcement) && (
                                                    <div>
                                                        <button type="submit" style={{ float: "right", textAlign: "right" }} className="btn btn-danger mr-sm-2" onClick={async () => { await deleteAnnouncements(announcement); setAnnouncements(await getAnnouncements()); }}> Delete </button>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>


                                    <p>&nbsp;</p>
                                </div>
                            )}

                        </>
                    }
                </>
            }
            <p>&nbsp;</p>
        </div>
    );
}

// Export the home Function
export default Announcements;
